module.exports = __webpack_public_path__ + "static/media/casesInactive.9ea638d4.svg";